import React from 'react';
import useFetch from 'use-http';
import Moment from 'react-moment';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import {
  Card,
  CardContent,
  CardHeader,
  CardFooter,
} from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Heading } from '@/components/ui/shared/heading';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import { SlashIcon, Download } from 'lucide-react';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { useUserState } from '@/components/context/UserContext';

const PathologyResearchDetails = () => {
  const history = useHistory();
  const research = history.location.state?.data;
  const { get: getFile } = useFetch('/UserAccount/DownloadAmisFile');
  const userState = useUserState();
  const handleFileDownload = async (filename, fileType, fileGuid) => {
    await getFile(
      `?fileType=${fileType}&fileGuid=${fileGuid}&category=PathologyResearch&espbiEsi=${userState.espbiEsi}`,
    ).then((res) => {
      const base64Data = res;
      const blob = base64toBlob(base64Data, 'application/pdf');
      const downloadLink = document.createElement('a');
      downloadLink.href = URL.createObjectURL(blob);
      downloadLink.download = `${trimFileName(filename)}.pdf`;
      document.body.appendChild(downloadLink);
      setTimeout(() => {
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }, 120);
    });
  };

  const base64toBlob = (base64Data, contentType = '') => {
    const sliceSize = 1024;
    const byteCharacters = atob(base64Data);
    const bytesLength = byteCharacters.length;
    const slicesCount = Math.ceil(bytesLength / sliceSize);
    const byteArrays = new Array(slicesCount);

    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      const begin = sliceIndex * sliceSize;
      const end = Math.min(begin + sliceSize, bytesLength);
      const bytes = new Array(end - begin);
      for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  };

  const trimFileName = (fileName) =>
    fileName.length > 190 ? fileName.substring(0, fileName.length - 18) + '...' : fileName;

  return (
    <div className="space-y-5">
      <Breadcrumb className="px-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/userAccount/pathology-researches">Patologiniai tyrimai</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator>
            <SlashIcon />
          </BreadcrumbSeparator>
          <BreadcrumbItem>
            <BreadcrumbPage>{research.name}</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      {/* Card 1: Research Info */}
      <Card>
        <CardHeader>
          <Heading variant="userAccountDetailsTitle">Tyrimo informacija</Heading>
        </CardHeader>
        <CardContent className="space-y-2">
          <div>
            <span>Tyrimo pavadinimas: </span>
            <span>{research.name}</span>
          </div>

          <div>
            <span>Būsena: </span>
            <span>{research.status}</span>
          </div>

          <div>
            <span>Data: </span>
            <span>
              {new Date(Date.parse(research.orderDate)).getUTCHours() === 0 ? (
                <Moment utc format="YYYY-MM-DD">
                  {research.orderDate}
                </Moment>
              ) : (
                <Moment utc format="YYYY-MM-DD HH:mm">
                  {research.orderDate}
                </Moment>
              )}
            </span>
          </div>

          <div>
            <span>Tyrimo tipas: </span>
            <span>{research.testType}</span>
          </div>
        </CardContent>
        <CardFooter />
      </Card>

      {/* Card 2: Dokumentai */}
      {research.fileName && research.fileGuid && research.fileType && (
        <Card>
          <CardHeader>
            <Heading variant="userAccountDetailsTitle">Dokumentai</Heading>
          </CardHeader>
          <CardContent>
            <Button
              variant="light"
              onClick={() => {
                const fileName =
                  research.fileName +
                  ' ' +
                  moment(new Date(research.performDate)).format('YYYY-MM-DD');
                handleFileDownload(fileName, research.fileType, research.fileGuid);
              }}
            >
              <Download />
              Atsisiųsti PDF
            </Button>
          </CardContent>
          <CardFooter />
        </Card>
      )}
    </div>
  );
};

export default PathologyResearchDetails;
